import Closeicon from "../../images/Closeicon";
import {ChatState} from "../../Context/ChatProvider";
import React, {useState} from "react";

const ProfileModal = ({ user,  children, setOpenAvatar }) => {
    const { openProfileModal, setOpenProfileModal} = ChatState();
    const [userFromLocalstorage, setUserFromLocalstorage] = useState(user);
    const userForAvatar = children ? userFromLocalstorage : user;
    
    return (
        <>
            {children
                 ? <span style={{background: "#fbfe0f", width: "49px", height: "40px", }} >{children}</span>
                 : <button onClick={setOpenProfileModal}  type='button' className='icon_button'  >
                         <span className='span_avatar'>
                              <img className='imgAvatar' name={user.name} src={user.pic} alt='imgAvatar'/>
                         </span>
                   </button>
            }
            { openProfileModal ? <div className=' timeProfile' >
                <div className = 'modalContent' >
                    <section className='modal_section' >
                        <div className = 'modal_header'>
                            {userForAvatar.name}
                        </div>
                        <button className='css-1ik4h6n buttonClose' type='button' aria-label='Close' onClick={()=>{setOpenProfileModal(false); !!setOpenAvatar && setOpenAvatar(false); }} ><Closeicon /></button>
                        <div className='modal_body'>
                            <img className='imgModal' alt={userForAvatar.name}  src={userForAvatar.pic} />
                            <p className='textLarge' > {userForAvatar.email} </p>
                        </div>
                        <div className='modal_footer'>
                            <button className=' button signup_button'  onClick={()=>{setOpenProfileModal(false); !!setOpenAvatar && setOpenAvatar(false); }} >Close</button>
                        </div>
                    </section>
                </div>
            </div>  : null}
        </>
    )
}
export default ProfileModal
